import React, { Component } from "react";
import EditInfoCard from "../../components/teams/EditInfoCard";

class TeamInfoContainer extends Component {
  handleCheck = (event, key, type) => {
    let newDefaultFields = this.props.tournament.defaultFields || {};
    // newDefaultFields[key] = newDefaultFields[key];
    if (newDefaultFields[key] === undefined) {
      newDefaultFields[key] = {};
    }
    newDefaultFields[key][type] = event.target.checked;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ defaultFields: newDefaultFields });
  };

  handleCheckPlayers = (event, key, type) => {
    let newDefaultFields = this.props.tournament.infoFieldsPlayers || {};
    // newDefaultFields[key] = newDefaultFields[key];
    if (newDefaultFields[key] === undefined) {
      newDefaultFields[key] = {};
    }
    newDefaultFields[key][type] = event.target.checked;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ infoFieldsPlayers: newDefaultFields });
  };

  handleCheckReferees = (event, key, type) => {
    let newDefaultFields = this.props.tournament.defaultFieldsReferees || {};
    // newDefaultFields[key] = newDefaultFields[key];
    if (newDefaultFields[key] === undefined) {
      newDefaultFields[key] = {};
    }
    newDefaultFields[key][type] = event.target.checked;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ defaultFieldsReferees: newDefaultFields });
  };

  handleQuestionCheck = (event, key) => {
    if (key === "1") {
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update({ showTeamSignupQuestion2Table: event.target.checked });
    } else {
      let questions = this.props.tournament.questions || {};
      if (questions[key] === undefined) {
        questions[key] = {};
      }
      questions[key]["show"] = event.target.checked;

      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update({ questions: questions });
    }
  };

  handleProductCheck = (event, key) => {
    let products = this.props.tournament.products || {};
    if (products[key] === undefined) {
      products[key] = {};
    }
    products[key]["show"] = event.target.checked;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ products: products });
  };

  handleWishCheck = (event, key) => {
    let teamWishes = this.props.tournament.teamWishes || {};
    if (teamWishes[key] === undefined) {
      teamWishes[key] = {};
    }
    teamWishes[key]["show"] = event.target.checked;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ teamWishes: teamWishes });
  };

  render() {
    return (
      <EditInfoCard
        tournament={this.props.tournament}
        handleCheck={this.handleCheck}
        handleCheckReferees={this.handleCheckReferees}
        handleQuestionCheck={this.handleQuestionCheck}
        handleProductCheck={this.handleProductCheck}
        handleWishCheck={this.handleWishCheck}
        refereesPage={this.props.refereesPage}
        handleToPlayersClick={this.props.handleToPlayersClick}
        handleToJudgesClick={this.props.handleToJudgesClick}
        days={this.props.days}
        teamsContactInfo={this.props.teamsContactInfo}
        playersContactInfo={this.props.playersContactInfo}
        handleCheckPlayers={this.handleCheckPlayers}
      />
    );
  }
}

export default TeamInfoContainer;
